import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { AssessmentTL2RelationshipStoreModel } from './assessment-tl2-relationship.model';

export type AssessmentTL2RelationshipState = EntityState<AssessmentTL2RelationshipStoreModel, object, number>;

@Injectable({ providedIn: 'root' })
export class AssessmentTL2RelationshipStore extends EntityStore<AssessmentTL2RelationshipState> {
  constructor() {
    super({
      name: 'assessments-tl2-relationships',
      idKey: 'id',
    });
  }
}
